/* Because — $9.99 trial landing page (Concept B). Vanilla JS, no dependencies. */
(function () {
  // Translucent navbar on scroll + release (slide away) once the trial selector is reached
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var selector = document.getElementById('selector');
    var set = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      if (selector) {
        header.classList.toggle('nav-released', selector.getBoundingClientRect().top <= header.offsetHeight);
      }
    };
    set();
    window.addEventListener('scroll', set, { passive: true });
    window.addEventListener('resize', set);
  })();

  // Reviews carousel — prev/next arrows, with end-state disabling
  (function () {
    var track = document.getElementById('reviewsTrack');
    if (!track) return;
    var prev = document.querySelector('.rev-arrow[data-rev=prev]');
    var next = document.querySelector('.rev-arrow[data-rev=next]');
    var step = function () { var c = track.querySelector('.review-card'); return c ? c.getBoundingClientRect().width + 16 : 320; };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    // Advance one card per arrow via instant scrollLeft. With scroll-snap it lands cleanly on a card,
    // and it works everywhere — including background/hidden tabs where animated scrolling is throttled.
    var slideBy = function (dir) {
      var max = track.scrollWidth - track.clientWidth;
      track.scrollLeft = Math.max(0, Math.min(max, track.scrollLeft + dir * step()));
      update();
    };
    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () { slideBy(btn.dataset.rev === 'next' ? 1 : -1); });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  // Selector product image: toggle pack <-> cross-section (canvas AND modal), swap both to the chosen
  // absorbency, and open a larger view in a modal. URLs come from data-pack/data-cutaway on the radios.
  (function () {
    var frame = document.querySelector('.selector-media__frame.prod-toggle');
    var form = document.querySelector('.selector');
    if (!frame || !form) return;
    var pack = document.getElementById('selectorProduct');
    var cutaway = document.getElementById('selectorCutaway');
    if (!pack || !cutaway) return;
    var dlg = document.getElementById('imgZoom');
    var zImg = dlg ? dlg.querySelector('.zoom-modal__img') : null;

    var view = 'pack';
    var activeImg = function () { return view === 'pack' ? pack : cutaway; };
    var apply = function () {
      frame.setAttribute('data-view', view);
      pack.hidden = view !== 'pack';
      cutaway.hidden = view !== 'cutaway';
      if (zImg && dlg.open) { var a = activeImg(); zImg.src = a.currentSrc || a.src; zImg.alt = a.alt; }
    };
    var flip = function () { view = view === 'pack' ? 'cutaway' : 'pack'; apply(); };

    // Canvas arrows and modal arrows both flip between the two views (modal stays in sync with the canvas).
    frame.querySelectorAll('.prod-toggle__arrow').forEach(function (btn) { btn.addEventListener('click', flip); });

    // Absorbency change → update BOTH images' src/alt; keep whichever view is showing.
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'abs') return;
      var p = e.target.getAttribute('data-pack');
      if (p) { pack.src = p; pack.alt = e.target.getAttribute('data-alt') || pack.alt; }
      var c = e.target.getAttribute('data-cutaway');
      if (c) { cutaway.src = c; cutaway.alt = e.target.getAttribute('data-cutaway-alt') || cutaway.alt; }
      apply();
    });

    // Magnify → open the current image larger.
    if (dlg && zImg) {
      var zoomBtn = frame.querySelector('.prod-toggle__zoom');
      if (zoomBtn) zoomBtn.addEventListener('click', function () {
        var a = activeImg(); zImg.src = a.currentSrc || a.src; zImg.alt = a.alt;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      });
      dlg.querySelectorAll('.zoom-modal__arrow').forEach(function (btn) { btn.addEventListener('click', flip); });
      var zClose = dlg.querySelector('[data-close-zoom]');
      if (zClose) zClose.addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
  })();

  // Trial checkout — resolve selected gender|absorbency|size to the "$9.99 Trial" variant and add it
  // to the cart on the trial selling plan, then go to /checkout. Mirrors the live /pages/start-full-trial.
  (function () {
    var cfgEl = document.getElementById('trial-config');
    var form = document.querySelector('.selector');
    if (!cfgEl || !form) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.sellingPlan || !cfg.variants) return;

    var val = function (name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    };

    form.querySelectorAll('.trial-cta').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (!val('size')) {
          var step = form.querySelector('input[name="size"]').closest('.selector__step');
          if (step) { step.classList.add('is-invalid'); step.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          var rq = document.getElementById('sizeRequired'); if (rq) rq.hidden = false;
          return;
        }
        var key = [val('gender'), val('abs'), val('size')].join('|');
        var variantId = cfg.variants[key];
        if (!variantId) { console.warn('No trial variant mapped for', key); return; }

        // Analytics: mirror the site's checkout funnel so paid traffic attributes during the live test.
        // Consent-gated (CIPA) the same way assets/store-locator.js gates its track() call: if the
        // visitor has explicitly NOT granted analytics consent, drop the event entirely — no dataLayer
        // push either, because GTM listeners can forward dataLayer events to third parties. GA4/Ads run
        // through the Littledata + Analyzify app embeds; this push is only for any GTM-driven listener.
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!(cp && typeof cp.userCanBeTracked === 'function' && !cp.userCanBeTracked())) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'trial_begin_checkout', trial_variant_id: variantId, trial_selection: key });
        }

        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.textContent = 'Starting your trial…';

        // Clear the cart, add the $9.99-trial variant on the trial selling plan, then go to checkout.
        // The inner query's "&" must be %26-encoded so they stay part of the outer return_to value.
        var add = '/cart/add?items[0][id]=' + variantId + '%26items[0][selling_plan]=' + cfg.sellingPlan + '%26return_to=/checkout';
        window.location.href = '/cart/clear?return_to=' + add;
      });
    });

    // Size starts unselected: clear the "choose a size" prompt + un-dim the CTA once a size is picked.
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'size') return;
      var step = e.target.closest('.selector__step');
      if (step) step.classList.remove('is-invalid');
      var rq = document.getElementById('sizeRequired'); if (rq) rq.hidden = true;
      form.querySelectorAll('.trial-cta').forEach(function (b) { b.classList.remove('is-inactive'); });
    });
  })();

  // Size-guide modal — open from "View sizing chart", close via button / backdrop / Esc
  (function () {
    var dlg = document.getElementById('sizeChart');
    if (!dlg) return;
    document.querySelectorAll('.size-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      });
    });
    var closeBtn = dlg.querySelector('[data-close-sizechart]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  })();
})();
